import { render, staticRenderFns } from "./QueueAppointment.vue?vue&type=template&id=08dd1031&scoped=true"
import script from "./QueueAppointment.vue?vue&type=script&lang=js"
export * from "./QueueAppointment.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=08dd1031&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd1031",
  null
  
)

export default component.exports